module.exports = __webpack_public_path__ + "img/aptamer-example.05877736.png";